module.exports = __webpack_public_path__ + "img/10.0babc4c5.jpg";